import { render, staticRenderFns } from "./WechatAvatar.vue?vue&type=template&id=6719bf4a&scoped=true"
import script from "./WechatAvatar.vue?vue&type=script&lang=js"
export * from "./WechatAvatar.vue?vue&type=script&lang=js"
import style0 from "./WechatAvatar.vue?vue&type=style&index=0&id=6719bf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6719bf4a",
  null
  
)

export default component.exports